import clsx from 'clsx'
import { useField } from 'formik'

/* blocks */
import { Tooltip } from '@/atoms/Tooltip/Tooltip'

/* styles */
import styles from './text.module.css'

interface Props {
  label?: string
  name: string
  className?: string
  inputClass?: string
  placeholder?: string
  labelClass?: string
  type?: 'text' | 'number' | 'password'
  required?: boolean
  tooltip?: string
}

const TextField = ({
  label,
  name,
  className,
  placeholder,
  inputClass,
  type = 'text',
  labelClass,
  required,
  tooltip
}: Props) => {
  const [field, meta] = useField<string | undefined>(name)

  return (
    <div className={clsx('input__container', className)}>
      {label && (
        <label
          className={clsx(
            labelClass,
            'text-gray-80 font-medium | mb-2 relative flex items-center gap-1'
          )}
          style={{ fontSize: 13 }}
          htmlFor={`form-${name}`}
        >
          <div className="flex items-center gap-1">
            <span>{label}</span>
            {required && <span className="text-orange-50">&nbsp;*</span>}
            {tooltip && (
              <Tooltip text={tooltip}>
                <div
                  className="tooltip-icon"
                  tabIndex={0}
                  aria-label="Tooltip info"
                >
                  <svg
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </div>
              </Tooltip>
            )}
          </div>
        </label>
      )}
      <input
        {...field}
        id={`form-${name}`}
        placeholder={placeholder}
        type={type}
        className={clsx(
          'border border-gray-40 rounded-lg  |  w-full h-12  |  px-4',
          inputClass,
          styles.input,
          (key: string) => styles[`input_${key}`]
        )}
        required={required}
      />
      {meta.touched && meta.error ? (
        <div className="text-small font-medium text-orange-50  |  mt-2">
          {meta.error}
        </div>
      ) : null}
    </div>
  )
}

export default TextField
